module.exports = "/images/minus-sign.svg?8955cf12007a686503aa83c637554ae4";